import type { RectShape } from '@model-framework/shape';

type Props = {
  shape: RectShape;
  margin: number;
};

export const NodeOtherUserSelected: React.FC<Props> = ({ shape, margin }: Props) => {
  return (
    <g transform={`translate(${-margin}, ${-margin})`}>
      {shape.resize({ margin }).render({
        fillOpacity: 0,
        strokeWidth: 10,
        pointerEvents: 'none',
        className: 'stroke-orange-400 fill-black',
      })}
    </g>
  );
};
